import { State, getState, updateState } from '../../utils/applicationState';
import { MediumTypes } from '../../utils/constants';
const isFirstInSessionController = {
    isFirstInSession: false,
    isFirstDisplayAdInSessionMap: {},
    getIsFirstInSessionFlag(slot) {
        if (!slot?.medium || !getState(State.playSessionId)) {
            return false;
        }
        switch (slot.medium) {
            case MediumTypes.video:
            case MediumTypes.audio: {
                return this.isFirstInSession;
            }
            case MediumTypes.display: {
                if (getState(State.isServingAudioOrVideoAd)) {
                    return false;
                }
                return this.isFirstDisplayAdInSession(slot);
            }
            default:
                return false;
        }
    },
    resetIsFirstInSessionFlag() {
        if (!getState(State.playSessionId)) {
            return;
        }
        this.isFirstInSession = true;
        this.bulkSetIsFirstInSessionDisplayAdFlag(true);
    },
    markFlagAsUsed(displaySlotId) {
        if (!getState(State.playSessionId) ||
            (displaySlotId && getState(State.isServingAudioOrVideoAd))) {
            return;
        }
        this.isFirstInSession = false;
        if (displaySlotId) {
            this.isFirstDisplayAdInSessionMap[displaySlotId] = false;
        }
        else {
            this.bulkSetIsFirstInSessionDisplayAdFlag(false);
        }
    },
    registerDisplayAdSlot(slotId) {
        if (!slotId) {
            return;
        }
        this.isFirstDisplayAdInSessionMap[slotId] = this.isFirstInSession;
    },
    deregisterDisplayAdSlot(slotId) {
        if (!slotId) {
            return;
        }
        delete this.isFirstDisplayAdInSessionMap[slotId];
    },
    isFirstDisplayAdInSession(slot) {
        if (!slot?.elementId) {
            return false;
        }
        const item = this.isFirstDisplayAdInSessionMap?.[slot.elementId];
        return item ?? false;
    },
    bulkSetIsFirstInSessionDisplayAdFlag(value) {
        Object.keys(this.isFirstDisplayAdInSessionMap).forEach((key) => {
            this.isFirstDisplayAdInSessionMap[key] = value;
        });
    },
};
export default isFirstInSessionController;
